import React from 'react'

export default function Calendar() {

  const info = [
    {
      day: "Monday",
      classes: ["5 PM: Youth Gloves Up", "7 PM: Strength & Conditioning"],
    },
    {
      day: "Tuesday",
      classes: ["7 PM: Technical Boxing L1"],
    },
    {
      day: "Wednesday",
      classes: ["12 pm: Cardio Boxing Lunch", "7 PM: Technical Sparring & Footwork"],
    },
    {
      day: "Thursday",
      classes: ["8 AM: Bonjour Strength and Conditioning ", "5 PM: Youth Gloves Up", "6:45 PM: Ladies Boxing"],
    },
    {
      day: "Friday",
      classes: ["6:30 PM: Cardio Boxing"],
    },
    {
      day: "Saturday",
      classes: ["11 AM: HIIT/MITT Fever"], 
    },
    {
      day: "Sunday",
      classes: ["10:30 AM: Hit Hard, HIIT Harder"],
    },
  ]
  return (
    <div className='calendar-parent'>
      <div className='justify-content-evenly calendar'>
        {info.map((day, index) => (
          <div className={`col day-parent${day.day === "Monday" ? "-monday" : ""}`} key={index}>
            <div className="day">
              {day.day}
            </div>
            {day.classes.map((classes, i) => (
              <div className="day-classes" key={i}>{classes}</div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
